import React from 'react'
import {connect} from 'react-redux'
import {Flex} from '/app/src/component'
import ItemView from './ItemView'
import {AutoMessageSelector} from '/app/src/model/AutoMessage'

class ItemScreen extends React.Component {
    render(){
        return (
            <Flex basis='100%' hAlignContent='center'>
                <ItemView
                    id={this.props.id}
                    action={this.props.action}
                    title={this.props.title}
                    message={this.props.message}
                    priority={this.props.priority}
                    url={this.props.url}
                    time={this.props.time}
                    visitor={this.props.visitor}
                    weekDays={this.props.weekDays}
                    frequency={this.props.frequency}
                    msgDuration={this.props.msgDuration}
                    nbrAutomessages={this.props.nbrAutomessages}
                />
            </Flex>
        )
    }
}

function mapStateToProps(state, props){
    let action = props.match.params.action

    let id, title, message, priority, url, time, visitor, weekDays, frequency, msgDuration, nbrAutomessages
    switch(action){
        case 'edit':
            id = props.match.params.id
            let automessage = AutoMessageSelector.getById(state, id)
            title = AutoMessageSelector.getTitle(automessage)
            message = AutoMessageSelector.getMessage(automessage)
            priority = AutoMessageSelector.getPriority(automessage)
            time = AutoMessageSelector.getTime(automessage).toJS()
            url = AutoMessageSelector.getUrl(automessage)
            visitor = AutoMessageSelector.getVisitor(automessage)
            frequency = AutoMessageSelector.getFrequency(automessage)
            weekDays = AutoMessageSelector.getWeekDays(automessage).toJS()
            msgDuration = AutoMessageSelector.getMessageDuration(automessage)
            break;
        case 'create':
        default:
            let automessages = AutoMessageSelector.getFrom(state).toList().toJS()
            priority = -1
            for (var i in automessages){
                if(automessages[i].message.message.priority > priority){
                    priority = parseInt(automessages[i].message.message.priority, 10)
                }
            }
            frequency = 'always'
            priority += 1
            title = 'Online - Standard'
            message = 'Hej! Vi är på plats och tar emot ditt meddelande så fort vi kan!'
            visitor = 'all'
            time = [{time_before: [8,0], time_after: [17,0]}]
            url = 'http'
            weekDays = [0,1,2,3,4]
            msgDuration = 10
            nbrAutomessages =  AutoMessageSelector.getFrom(state).size
            break;
    }
    return {
       action, id, title, message, priority, time, url, visitor, weekDays, frequency, msgDuration, nbrAutomessages
   }
}
export default connect(mapStateToProps)(ItemScreen)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/AutoMessage/ItemScreen/index.js